import type { GatewayTimeFilterInput, ResolvedGatewayTimeFilter } from '../types/gateway-filter.type'
import {
  GATEWAY_TIME_FILTER_ALL,
  GATEWAY_TIME_FILTER_DEFAULT,
  GATEWAY_TIME_RANGE_PRESET_WINDOWS_MS,
} from '../types/gateway-filter.type'

const CUSTOM_TIME_RANGE_VALUE = 'custom'

function isExplicitUnixRange(dateFrom: string, dateTo: string): boolean {
  const fromMs = Number(dateFrom)
  const toMs = Number(dateTo)
  return Number.isFinite(fromMs) && Number.isFinite(toMs) && fromMs > 0 && toMs >= fromMs
}

export function resolveGatewayTimeFilter(input?: GatewayTimeFilterInput): ResolvedGatewayTimeFilter {
  if (input?.dateFrom === GATEWAY_TIME_FILTER_ALL.dateFrom && input?.dateTo === GATEWAY_TIME_FILTER_ALL.dateTo) {
    return GATEWAY_TIME_FILTER_ALL
  }

  if (input?.dateFrom != null && input?.dateTo != null && isExplicitUnixRange(input.dateFrom, input.dateTo)) {
    return { dateFrom: input.dateFrom, dateTo: input.dateTo }
  }

  return GATEWAY_TIME_FILTER_DEFAULT
}

type GatewayCustomRangeApplied = {
  startAt: Date | number
  endAt: Date | number
}

function toEpochMsString(value: Date | number): string {
  return String(typeof value === 'number' ? value : value.getTime())
}

export function resolveGatewayTimeFilterFromPreset(
  preset: string,
  customRange?: GatewayCustomRangeApplied | null
): ResolvedGatewayTimeFilter {
  if (preset === CUSTOM_TIME_RANGE_VALUE) {
    if (customRange?.startAt != null && customRange?.endAt != null) {
      return {
        dateFrom: toEpochMsString(customRange.startAt),
        dateTo: toEpochMsString(customRange.endAt),
      }
    }

    return GATEWAY_TIME_FILTER_DEFAULT
  }

  const windowMs = GATEWAY_TIME_RANGE_PRESET_WINDOWS_MS[preset]
  if (!windowMs) {
    return GATEWAY_TIME_FILTER_DEFAULT
  }

  const dateTo = Date.now()
  return {
    dateFrom: String(dateTo - windowMs),
    dateTo: String(dateTo),
  }
}
